import React from 'react';
import { Button, Space, Tag, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { HamburguerIcon, Notifications, Wrapper } from 'components';
import { toggleDatasource } from 'core/actions';

const { Text, Title } = Typography;
const REFRESH_EVENT = 'synapse:tenants:refresh';

export default function TenantsToolbar({
	menuIsOpen,
	isMobile,
	theme,
	isDarkTheme,
}) {
	const dispatch = useDispatch();

	return (
		<Wrapper
			padding='10px 12px'
			width='100%'
			height='56px'
			justifyContent='space-between'
			backgroundColor={
				isDarkTheme
					? theme._secondaryBackgroundColor
					: theme._primaryBackgroundColor
			}
		>
			<Space align='center'>
				{!menuIsOpen && (
					<HamburguerIcon button onClick={() => dispatch(toggleDatasource())} />
				)}
				<Space direction='vertical' size={0}>
					<Title level={5} style={{ margin: 0 }}>
						Tenants
					</Title>
					<Text type='secondary'>
						Provisioning operativo de clientes nuevos
					</Text>
				</Space>
			</Space>

			<Space align='center'>
				<Tag color='blue'>Synapse Ops</Tag>
				<Button
					icon={<ReloadOutlined />}
					onClick={() => window.dispatchEvent(new Event(REFRESH_EVENT))}
				>
					Recargar
				</Button>
				<Notifications isMobile={isMobile} />
			</Space>
		</Wrapper>
	);
}
